import {useCallback} from 'react';

import type {Props} from './types';

export const useController = ({isActive, isDisabled, onClick}: Props) => {
  const onClickCb = useCallback(() => {
    if (isDisabled) {
      return;
    }

    onClick(!isActive);
  }, [isActive, isDisabled, onClick]);

  return {onClick: onClickCb};
};
